// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"Breadcrumbs_breadcrumbs__tR7bA","breadcrumb":"Breadcrumbs_breadcrumb__vD3Pq","active":"Breadcrumbs_active__LB+Ro"};